import { render, staticRenderFns } from "./information-disclosure.vue?vue&type=template&id=0c257912&scoped=true"
var script = {}
import style0 from "./information-disclosure.vue?vue&type=style&index=0&id=0c257912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c257912",
  null
  
)

export default component.exports